import { Injectable } from '@angular/core';
import { AuthService } from '@app/auth.service';
interface isLoggedIn {
  status: boolean
}

interface logoutStatus {
  status: boolean
}

@Injectable()
export class UserService {

  constructor(private Auth: AuthService) { }

  isLoggedIn() {
    const result: isLoggedIn = {
      status: false
    };

    const member_info = JSON.parse(sessionStorage.getItem('member_obj'));
    if (member_info != null) {
      if (member_info.member_no != '') {
        result.status = true;
      }
    }
    return result;
  }

  logout() {
    localStorage.setItem('dpa_portal', null);
    this.Auth.setLoggedIn(false);
    const result: isLoggedIn = {
      status: true
    };
    return result;
  }


}



// WEBPACK FOOTER //
// ./src/app/user.service.ts